<div class="modal-header">
  <div class="d-flex align-items-center gap-2">
    <h5 class="modal-title" i18n>Add Discount Code</h5>
    <app-page-help articleId="sb2ioicmcp"></app-page-help>
  </div>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body bg-none p-0 m-0">
  <form [formGroup]="form" [formEditablePermission]="form">
    <div class="p-3">
      <div class="row">
        <div class="col-md-6">
          <label class="form-field-label">
            <ng-container i18n>Type</ng-container> <span class="text-danger">*</span>
          </label>
          <div class="d-flex gap-3">
            <button
              class="btn flex-1"
              (click)="form.get('type').setValue('flat')"
              [ngClass]="form.get('type').value == 'flat' ? 'btn-success' : 'btn-outline-success'"
              matTooltip="Exact value set in Amount field will be discounted from booking total"
              i18n-matTooltip
            >
              <i class="fas fa-dollar-sign"></i> <ng-container i18n>Flat</ng-container>
            </button>
            <button
              class="btn flex-1"
              (click)="form.get('type').setValue('pct')"
              [ngClass]="form.get('type').value == 'pct' ? 'btn-info' : 'btn-outline-info'"
              matTooltip="Percentage of booking total will be discounted"
              i18n-matTooltip
            >
              <i class="fas fa-percent"></i> <ng-container i18n>Percentage</ng-container>
            </button>
          </div>
        </div>
        <div class="col-md-6">
          <mat-form-field2
            class="d-block"
            matTooltip="Enter the name for this discount"
            matTooltipPosition="above"
            i18n-matTooltip
          >
            <input matInput placeholder="Name" i18n-placeholder formControlName="name" type="text" required />
            <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('required')">
              <ng-container i18n>Name is required</ng-container>
            </mat-error>
            <mat-error i18n *ngIf="form.get('name').hasError('maxlength')">
              Name must be at most 50 characters
            </mat-error>
            <mat-error i18n *ngIf="form.get('name').hasError('allWhitespace')"> Name is invalid </mat-error>
            <mat-hint align="end"> {{ form.get('name').value.length || 0 }}/50</mat-hint>
          </mat-form-field2>
        </div>
        <div class="col-sm-12">
          <mat-form-field2
            class="d-block"
            matTooltip="Enter the description for this discount"
            matTooltipPosition="above"
            i18n-matTooltip
          >
            <textarea
              matInput
              placeholder="Description"
              i18n-placeholder
              formControlName="description"
              type="text"
              rows="2"
              required
              cdkTextareaAutosize
              [cdkAutosizeMaxRows]="4"
            ></textarea>
            <mat-error *ngIf="form.get('description').touched && form.get('description').hasError('required')">
              <ng-container i18n>Description is required</ng-container>
            </mat-error>
            <mat-error i18n *ngIf="form.get('description').hasError('maxlength')">
              Description must be at most 150 characters
            </mat-error>
            <mat-hint align="end"> {{ form.get('description').value.length || 0 }}/150</mat-hint>
          </mat-form-field2>
        </div>
      </div>
    </div>
    <div class="p-3 border-top">
      <div class="row">
        <div class="col-md-3">
          <mat-form-field2 class="d-block">
            <input
              matInput
              matTooltip="Enter the discount amount"
              matTooltipPosition="above"
              i18n-matTooltip
              type="number"
              [placeholder]="amountPlaceholder"
              formControlName="amount"
              required
            />
            <mat-error *ngIf="form.get('amount').touched && form.get('amount').hasError('percent')">
              <ng-container i18n>Amount should be greater than 0 and less than 100</ng-container>
            </mat-error>
            <mat-error *ngIf="form.get('amount').touched && form.get('amount').hasError('positive')">
              <ng-container i18n>Amount should be greater than 0</ng-container>
            </mat-error>
            <mat-error *ngIf="form.get('amount').touched && form.get('amount').hasError('required')">
              <ng-container i18n>Amount is required</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-md-3">
          <mat-form-field2 class="d-block">
            <input
              matInput
              i18n-matTooltip
              matTooltip="Enter the minimum booking total required for the discount"
              matTooltipPosition="above"
              type="number"
              placeholder="Booking Total"
              i18n-placeholder
              formControlName="booking_total_min"
            />
            <mat-error
              *ngIf="form.get('booking_total_min').touched && form.get('booking_total_min').hasError('positive')"
            >
              <ng-container i18n>Amount should be greater than</ng-container> <b>0</b>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-md-3">
          <mat-form-field2 class="d-block">
            <input
              matInput
              matTooltip="Enter value for number of uses allowed for this discount"
              matTooltipPosition="above"
              i18n-matTooltip
              type="number"
              placeholder="Max Uses"
              i18n-placeholder
              formControlName="max_uses"
              required
            />
            <mat-error *ngIf="form.get('max_uses').touched && form.get('max_uses').hasError('min')">
              <ng-container i18n>Max Uses should not be less than</ng-container>&nbsp;
              <strong>{{ item?.bookings?.length || 1 }}</strong>
            </mat-error>
            <mat-error *ngIf="form.get('max_uses').touched && form.get('max_uses').hasError('required')">
              <ng-container i18n>Max Uses is required</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-md-3">
          <mat-form-field2 class="d-block">
            <mat-label>
              <ng-container i18n>Min Stay</ng-container> <span class="text-light" i18n>(nights)</span>
            </mat-label>
            <input
              matInput
              matTooltip="Enter the minimum length of stay required for the discount"
              matTooltipPosition="above"
              i18n-matTooltip
              type="number"
              placeholder="Min Stay"
              i18n-placeholder
              formControlName="los"
            />
            <mat-error *ngIf="form.get('los').touched && form.get('los').hasError('min')">
              <ng-container i18n>Minimum Stay should not be less than 1</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-sm-6">
          <mat-form-field2
            class="mat-block"
            matTooltip="Select the start date for this discount"
            matTooltipPosition="above"
            i18n-matTooltip
          >
            <input
              matInput
              [matDatepicker]="startPicker"
              [max]="maxStartDate.value"
              [min]="now"
              placeholder="Start"
              i18n-placeholder
              formControlName="start"
              (focus)="startPicker.open()"
              tabindex="4"
              readonly
            />
            <i matSuffix (click)="startPicker.open()" class="cs-icon cs-icon-calendar"></i>
            <mat-datepicker #startPicker></mat-datepicker>
            <mat-error *ngIf="form.get('start').touched && form.get('start').hasError('required')">
              <ng-container i18n>Value is required</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>

        <div class="col-sm-6">
          <mat-form-field2
            class="mat-block"
            matTooltip="Select the end date for this discount"
            matTooltipPosition="above"
            i18n-matTooltip
          >
            <input
              matInput
              [matDatepicker]="endPicker"
              [min]="minEndDate.value"
              placeholder="Expires"
              i18n-placeholder
              formControlName="expires"
              (focus)="endPicker.open()"
              tabindex="4"
              readonly
            />
            <i matSuffix (click)="endPicker.open()" class="cs-icon cs-icon-calendar"></i>
            <mat-datepicker #endPicker></mat-datepicker>
            <mat-error *ngIf="form.get('expires').touched && form.get('expires').hasError('required')">
              <ng-container i18n>Value is required</ng-container>
            </mat-error>
            <mat-error *ngIf="form.get('expires').hasError('matDatepickerMin')">
              <ng-container i18n>Min value is</ng-container>&nbsp;
              <strong>{{ form.get('expires').getError('matDatepickerMin').min | epoch : 'DD-MMM-YYYY' }}</strong>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-md-6">
          <mat-form-field2 class="d-block">
            <input
              matInput
              matTooltip="Enter email address of the guest"
              matTooltipPosition="above"
              i18n-matTooltip
              type="email"
              placeholder="Email"
              i18n-placeholder
              formControlName="email"
            />
            <mat-error *ngIf="form.get('email').hasError('email')">
              <ng-container i18n>Email is invalid</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-md-6">
          <app-rental-select
            [ctrl]="rentalIdsCtrl"
            [multiple]="true"
            [excludeSubunits]="true"
            i18n-matTooltip
            i18n-placeholder
            matTooltip="Click here to select the rentals for which a discount code will be created. If no rental is selected, the discount will apply to all rentals"
            placeholder="Rentals"
          ></app-rental-select>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer border-top">
  <button (click)="close()" type="button" class="btn btn-light">
    <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
  </button>
  <button (click)="onSave(form)" type="button" class="btn btn-secondary-info create-btn">
    <i class="cs-icon cs-icon-save"></i> <ng-container i18n>Save</ng-container>
  </button>
</div>
